import * as React from "react"
import { ReadspeakerProps } from "./readspeaker.state"
import i18next from "i18next"

export const ReadSpeakerLayout = {
  Button: (props: ReadspeakerProps) => (
    <div id="readspeaker-rc" className="read-speaker rs_skip remprint">
        <div id={`readspeaker_button_${props.keyId}`} className="rs_skip rsbtn rs_preserve">
            <a
              rel="nofollow"
              className="rsbtn_play link link--icon"
              accessKey="L"
              title={i18next.t("General:ReadspeakerTitleSRT")}
              href={`https://app-eu.readspeaker.com/cgi-bin/rsent?customerid=11489&lang=nl_nl&readid=${props.readElementId}&url=${props.encodedUrl}`}
            >
              <span className="link__label">{i18next.t("General:ReadspeakerTitle")}</span>
              <svg className="link__icon" width="20px" height="20px" aria-hidden="true"><use xlinkHref="#icon--speak"></use></svg>
            </a>
        </div>
    </div>
  ),
}
